import { PersonSalaryActionTypes } from "models/actionTypes/personSalaryActionTypes";
import { ReduxConstants } from "utils/constants";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";

export const personSalaryReportUpdated = (
  personSalaryReport: WintSuperkollAPIModel.PersonSalaryReport
): PersonSalaryActionTypes => {
  return {
    type: ReduxConstants.PersonSalaryActions.PERSON_SALARY_REPORT_UPDATED,
    payload: personSalaryReport,
  };
};

export const personSalaryReportCompleted = (id: number): PersonSalaryActionTypes => {
  return {
    type: ReduxConstants.PersonSalaryActions.PERSON_SALARY_REPORT_COMPLETED,
    payload: id,
  };
};
